import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { Link, Text } from '@beef/ui-kit';

import { Picture } from 'components';

import abTestData from '../../abTestData';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

export const InsuranceBanner = ({ abTestVar }) => {
  const {
    imageMobile, imageTablet, title, description, notice, buttonText, redirectUrl, backgroundColor, imageAlt,
  } = abTestData[abTestVar || 0];

  const pictureContent = [
    { image: imageMobile, media: '(min-width: 200px) and (max-width: 399px)' },
    { image: imageTablet, media: '(min-width: 400px)' },
  ];

  return (
    <div
      className={cx('block', { [`block--${backgroundColor}`]: true })}
    >
      <div className={cx('block__image-container')}>
        <Picture
          content={pictureContent}
          defaultImage={imageMobile}
          alt={imageAlt}
        />
      </div>
      <div className={cx('block__content')}>
        <div className={cx('content__header')}>
          <Text size="size3-b" tagType="h2">
            {title}
          </Text>
        </div>
        <div className={cx('content__text')}>
          <Text size="size5-r" tagType="p">
            {description}
          </Text>
        </div>
        <div className={cx('content__link')}>
          <Link
            variant="button"
            buttonVariant="main"
            buttonSize="s"
            href={redirectUrl}
          >
            {buttonText}
          </Link>
        </div>
        <Text size="size7-r" tagType="p" color="grey40">
          {notice}
        </Text>
      </div>
    </div>
  );
};

InsuranceBanner.propTypes = {
  abTestVar: PropTypes.number,
};
